import {useState} from 'react';

const useDetailsResize = (element: HTMLElement, initialHeight: number) => {
  const [ heightFromTop, setHeightFromTop ] = useState(initialHeight);

  window.addEventListener('scroll', () => {
    if(element != null) setHeightFromTop(window.innerHeight - element.getBoundingClientRect().top)
  });

  return heightFromTop;
};

export default useDetailsResize